import { Component, Input, OnInit } from '@angular/core';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { DiscountDetailRecord, DiscountRecord, PartnerRecord, ProductUnit } from '@core/services/data.service';
import { Multilingual } from '@core/utilities/multilingual';
import { SynchronizationService } from '@core/services/synchronization.service';
import { TagsService } from '@core/services/tags.service';
import { PartnersService } from '@core/services/partners.service';


@Component({
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {

  @Input()
  public discount: DiscountRecord;
  @Input()
  public mode: 'import' | 'export' | 'full' = 'full';

  @Input()
  public counters: { Stamp: number, Tag: string, Amount: number }[] = [];

  public details = new Filterable<DiscountDetailRecord>();

  public get title(): string {

    return Multilingual.getText('Đơn trừ hàng lỗi') + ' L' + this.discount.ID + (this.sync.ready(PartnersService) && this.mode != 'full' ? ' ' + Multilingual.getText('cho') + ' ' + this.partner.Name : '');
  }

  public get hasLength(): boolean {
    return this.details.matches.first(i => i.Unit == ProductUnit.Meter, null) != null;
  }

  public get hasWeight(): boolean {
    return this.details.matches.first(i => i.Unit == ProductUnit.Kilogram, null) != null;
  }

  constructor(private sync: SynchronizationService, private tags: TagsService, private partners: PartnersService) { }

  ngOnInit(): void {

    this.sync.when(TagsService, PartnersService).commit(() => {
      this.details.source = this.discount.Details;
    });    
  }

  public extractor(field: string): SortableExtractor<DiscountDetailRecord> {
    return {
      extract: i => {
        switch (field) {
          case 'ReducedQuantity': return i.ActualQuantity - (this.mode == 'import' ? i.ImportQuoteQuantity : i.ExportQuoteQuantity);
          case 'ImportDiscountAmount': return i.ImportUnitPrice * i.ImportDiscountQuantity;
          case 'ExportDiscountAmount': return i.ExportUnitPrice * i.ExportDiscountQuantity;
          default: return i[field];
        }
      }
    }
  }

  public sum(field: string): number {
    switch (field) {
      case 'ReducedQuantity': return this.details.matches.sum(i => i.ActualQuantity - (this.mode == 'import' ? i.ImportQuoteQuantity : i.ExportQuoteQuantity));
      case 'ImportDiscountAmount': return this.details.matches.sum(i => i.ImportUnitPrice * i.ImportDiscountQuantity);
      case 'ExportDiscountAmount': return this.details.matches.sum(i => i.ExportUnitPrice * i.ExportDiscountQuantity);
      default: return this.details.matches.sum(i => i[field]);
    }
    
  }

  public name(tag: string): string {
    let t = this.tags.get(tag);
    if (!t) return '';
    let p = this.partners.get(t.PartnerID);
    return p ? p.Name : '';
  }

  public get partner(): PartnerRecord {
    return this.partners.get(this.mode == 'import' ? this.discount.CustomerID : this.discount.VendorID);
  }

  public get countered(): number {
    return this.counters.sum(i => i.Amount);
  }

  public get left(): number {
    return this.total - this.countered;
  }

  public get total(): number {
    return this.mode == 'import' ? this.discount.ImportDiscountAmount : this.discount.ExportDiscountAmount;
  }

  public get icon(): string {
    return this.mode == 'import' ? this.discount.ImportDiscountIcon : this.discount.ExportDiscountIcon;
  }
}
